/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import Menu$1 from './Menu.js';
import './style/css.js';
import './type.js';
import '../_chunks/dep-8c8a3203.js';
import 'react';
import 'classnames';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import './MenuContext.js';
import '../_util/noop.js';
import './_util/constant.js';
import './hooks/useMenuContext.js';
import '../_chunks/dep-f41383e1.js';
import '../_chunks/dep-f66447d3.js';
import '../_chunks/dep-605e961c.js';
import './_util/checkSubMenuChildExpanded.js';
import './_util/type.js';
import './defaultProps.js';
import './HeadMenu.js';
import '../tabs/index.js';
import '../tabs/Tabs.js';
import '../tabs/TabNav.js';
import 'tdesign-icons-react';
import '../_chunks/dep-ac257584.js';
import '../_chunks/dep-37e82645.js';
import '../_chunks/dep-a0293295.js';
import '../tabs/useTabClass.js';
import '../tabs/TabNavItem.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-378695bd.js';
import '../_util/easing.js';
import '../hooks/useDomRefCallback.js';
import '../hooks/useGlobalIcon.js';
import '../tabs/TabBar.js';
import '../_util/useMutationObserver.js';
import '../_common/js/tabs/base.js';
import '../tabs/TabPanel.js';
import '../tabs/defaultProps.js';
import '../_util/useDragSorter.js';
import '../tabs/style/css.js';
import '../tabs/type.js';
import './_util/checkSubMenuActive.js';
import './_util/checkMenuType.js';
import './_util/checkSubMenuChildrenActive.js';
import './SubMenu.js';
import './_util/getSubMenuChildStyle.js';
import '../common/FakeArrow.js';
import './_util/cacularPaddingLeft.js';
import './MenuItem.js';
import './MenuGroup.js';

var Menu = Menu$1;

export { Menu, Menu as default };
//# sourceMappingURL=index.js.map
